"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.InlineResponse2007ToJSON = exports.InlineResponse2007FromJSONTyped = exports.InlineResponse2007FromJSON = void 0;
function InlineResponse2007FromJSON(json) {
    return InlineResponse2007FromJSONTyped(json, false);
}
exports.InlineResponse2007FromJSON = InlineResponse2007FromJSON;
function InlineResponse2007FromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'portalUrl': json['portalUrl'],
    };
}
exports.InlineResponse2007FromJSONTyped = InlineResponse2007FromJSONTyped;
function InlineResponse2007ToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'portalUrl': value.portalUrl,
    };
}
exports.InlineResponse2007ToJSON = InlineResponse2007ToJSON;
